const CautionIconSVG = ({ color = '#000', size = '40px' }) => (
  <svg
    width={size}
    height={size}
    strokeWidth="1.8"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
  >
    <path
      d="M20.0429 21H3.95705C2.41902 21 1.45658 19.3364 2.22324 18.0031L10.2662 4.01533C11.0352 2.67792 12.9648 2.67791 13.7338 4.01532L21.7768 18.0031C22.5434 19.3364 21.581 21 20.0429 21Z"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
    ></path>
    <path d="M12 9V13" stroke={color} strokeWidth="1.8" strokeLinecap="round"></path>
    <path
      d="M12 17.01L12.01 16.9989"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
  </svg>
)

export default CautionIconSVG
